import { SingleIndex } from '@deqo/foundation';
import { differenceInDays, differenceInWeeks, startOfDay, startOfWeek } from 'date-fns';
import { useMemo } from 'react';
import { SortMode } from '../../common/Sorter';

const bucketDefs = {
    today: '% Today',
    yesterday: '% Yesterday',
    thisWeek: '% This Week',
    lastWeek: '% Last Week',
    whileAgo: '% a while ago...',
    never: 'Never %',
};

const assignBucket = (item: any, prop: string): keyof typeof bucketDefs => {

    const date = item[prop];

    if (date instanceof Date) {
        const dd = differenceInDays(
            startOfDay(new Date()),
            startOfDay(date)
        );

        if (dd === 0) return 'today';
        if (dd === 1) return 'yesterday';

        const dw = differenceInWeeks(
            startOfWeek(new Date()),
            startOfWeek(date)
        );

        if (dw === 0) return 'thisWeek';
        if (dw === 1) return 'lastWeek';

        return 'whileAgo';
    }
    else {
        return 'never';
    }
};

const reverseIfAsc = <T extends unknown>(items: T[], order: 'asc' | 'desc') =>
    order === 'asc' ? items.slice().reverse() : items;

export type Bucket<T> = {
    key: string,
    label: string,
    prop: string,
    items: T[],
};

export const useDateBuckets = <T extends unknown>(allItems: T[], [prop, order]: SortMode, sortLabels: Record<string, string>) =>
    useMemo(
        () => {
            const index = new SingleIndex<string, any>();
            allItems.forEach(x => index.add(assignBucket(x, prop), x));

            const keys = reverseIfAsc(Object.keys(bucketDefs), order);
            const buckets = keys.map(x => ({
                key: x,
                label: bucketDefs[x].replace('%', sortLabels[prop]),
                prop,
                items: Array.from(index.get(x)),
                order: keys.indexOf(x),
            }));

            // return reverseIfAsc(buckets as Bucket<T>[], order);
            return buckets as Bucket<T>[];
        },
        [allItems, prop, order, sortLabels]
    );

// console.dir(index.dir());
// return reverseIfAsc(Object.keys(bucketDefs), order).map(x => {
//     console.log(x);
//     const items = reverseIfAsc(sortItems(Array.from(index.get(x)), prop), order);
//     return { key: x, prop, items } as Bucket<T>;
// });

